const ProductType = Object.freeze({
  coolPrivilege: 'COOL_PRIVILEGE',
  device: 'DEVICE',
  package: 'PACKAGE',
});

export default ProductType;
